/**
 * @flow
 * @author: Anesh Parvatha
 */

// ----- zIndex stats -----

// WRITE ALL zIndex values here so that it wont break other elements

export const MOBILE_BOOK_NOW_BOTTOM_FIXED_BUTTON_Z_INDEX = 10
export const SLOT_BOOKING_FORM_MODAL_Z_INDEX = 100
export const SLOT_BOOKING_RESPONSE_MODAL_Z_INDEX = 1000
export const SLOT_BOOKING_SUCCESS_RESPONSE_MODAL_Z_INDEX = 101

// ----- zIndex ends -----



// WEBPACK FOOTER //
// ./src/themes/Metrics.js